import { getBaseApi } from './runtimeOrg';
import { getSessionEpoch } from './session';

let refreshInFlight: Promise<string> | null = null;

export const refreshAccessToken = (): Promise<string> => {
  if (refreshInFlight) return refreshInFlight;

  refreshInFlight = (async () => {
    const base = getBaseApi();
    const refreshToken = localStorage.getItem('refreshToken');
    const epoch = getSessionEpoch();

    if (!refreshToken) throw new Error('No refresh token available');
    if (!base) throw new Error('API base URL not configured');

    const res = await fetch(`${base}/auth/api/v1/token/refresh/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh: refreshToken }),
    });

    if (!res.ok) throw new Error('Failed to refresh access token');

    const data = await res.json();
    if (!data?.access) throw new Error('Refresh response missing access token');

    if (
      epoch !== getSessionEpoch() ||
      localStorage.getItem('refreshToken') !== refreshToken
    ) {
      throw new Error('Session ended while refreshing');
    }

    localStorage.setItem('accessToken', data.access);
    if (data.refresh) localStorage.setItem('refreshToken', data.refresh);
    return data.access as string;
  })().finally(() => {
    refreshInFlight = null;
  });

  return refreshInFlight;
};
